module.exports = __webpack_public_path__ + "img/xg-bg.21450ef4.jpg";